import DonutScore from "@memorang/ui/src/components/DonutScore";
/* -----------------UI--------------- */
import { Button, List } from "react-native-paper";
/* -----------------Globals--------------- */

type Props = {
	title: string;
	description: string;
	score: number;
	cta: string;
	numericId: number;
	appFont: string;
	isWeb: boolean;
	handleNavigation: (numericId: number) => void;
};
export const PracticeTestCardListItem = ({
	title,
	description,
	score,
	cta,
	numericId,
	appFont,
	isWeb,
	handleNavigation,
}: Props) => {
	return (
		<List.Item
			onPress={isWeb ? () => handleNavigation(numericId) : undefined}
			title={title}
			description={description}
			titleNumberOfLines={2}
			titleStyle={{
				fontFamily: `${appFont}-semibold`,
				fontSize: 14,
			}}
			descriptionStyle={{
				fontSize: 12,
			}}
			style={{
				paddingLeft: 16,
				paddingRight: 16,
			}}
			left={(p) => (
				<List.Icon
					{...p}
					style={{
						marginLeft: 0,
					}}
					icon={() => (
						<DonutScore
							variant="progress"
							distribution={[score, 100 - score]}
							score={score}
						/>
					)}
				/>
			)}
			right={(p) => (
				<List.Icon
					{...p}
					icon={() => (
						<Button onPress={() => handleNavigation(numericId)} mode="text">
							{cta}
						</Button>
					)}
				/>
			)}
		/>
	);
};
